import PropTypes from 'prop-types'
import Img from '../../../../../../../src/components/shared/Img'
import PrimaryButton from 'src/components/shared/PrimaryButton'
import { APPLY_FDR_URL } from '../../../../../../common/constants'
import { useLeadId } from '../../../../../../common/lead-id'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { buildQueryString } from '../../../../../../common/utils'

const StepItem = ({
  item,
  reverse,
  stepNumber,
  isMobile,
  bgColor,
  primaryBtnClassName,
  primaryBtnName,
}) => {
  const imageObj = isMobile ? item.img.mobile : item.img.desktop
  const leadId = useLeadId()
  const { query: baseQuery } = useRouter()

  let query = useMemo(
    () => buildQueryString(baseQuery, leadId),
    [baseQuery, leadId]
  )

  const url = `${APPLY_FDR_URL()}?${query}`

  return (
    <div
      className={classNames(
        'px-4 lg:px-0',
        { 'lg:bg-white': reverse },
        { 'lg:bg-blue-base-white': !reverse }
      )}
      id={`step-item-${item.id}`}
    >
      <div
        className={classNames(
          'border-gray-45 col-span-full grid grid-cols-4 gap-x-8 rounded border p-8 lg:grid-cols-12 lg:border-0 xl:p-0',
          bgColor
        )}
        data-testid={`step-item-${item.id}`}
      >
        <div
          className={classNames(
            'col-span-full my-auto text-left lg:col-span-4',
            { 'lg:order-2 lg:col-start-8': reverse },
            { 'lg:order-1 lg:col-start-2': !reverse }
          )}
          data-testid="step-item-text-container"
        >
          <div className="size-5 lg:size-12.5 mb-2 flex items-center justify-center rounded-full border border-black-base p-3 lg:mb-8 lg:border-2 lg:p-0">
            <span className="text-15 lg:text-xl lg:font-bold">
              {stepNumber}
            </span>
          </div>

          <h3
            className="mb-0 min-h-20 text-xl font-medium leading-10 lg:mb-4 lg:text-3xl"
            id={`step-item-${item.id}-stepTitle`}
          >
            {item.stepTitle}
          </h3>
          {!isMobile ? (
            <p
              className={classNames('leading-7 text-gray-960 ', {
                'lg:mb-12': item.showButton,
              })}
            >
              {item.stepDescription}
            </p>
          ) : null}

          {item.showButton && !isMobile ? (
            <PrimaryButton
              isLeadCta={item.isLeadCta}
              title={primaryBtnName}
              sectionTitle={item.stepTitle}
              href={url}
              id={`step-item-${item.id}-button`}
              className={classNames('inline px-5 py-2.5', primaryBtnClassName)}
            />
          ) : null}
        </div>
        <div
          className={classNames(
            'col-span-full lg:col-span-4',
            { 'lg:order-1 lg:col-start-2': reverse },
            { 'lg:order-2 lg:col-start-8': !reverse }
          )}
          data-testid="step-item-image-container"
        >
          <Img
            src={imageObj.src}
            alt={imageObj.alt}
            dataTestId={`${item.id}-image-test-id`}
            width={640}
            height={420}
            layout="responsive"
            styles={{ position: 'relative' }}
          />
          {isMobile ? (
            <p className="mb-0 min-h-52 text-left text-15 leading-7 text-gray-960 lg:mb-12">
              {item.stepDescription}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  )
}

StepItem.defaultProps = {
  bgColor: '',
  primaryBtnClassName: 'bg-blue-base text-white',
  primaryBtnName: 'Get started',
}

StepItem.propTypes = {
  item: PropTypes.object.isRequired,
  reverse: PropTypes.bool.isRequired,
  stepNumber: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  bgColor: PropTypes.string,
  primaryBtnClassName: PropTypes.string,
  primaryBtnName: PropTypes.string,
}
export default StepItem
